import {AudioFileMetaDataEntity} from '@spout/any-shared/models';

export function fileBlobPathBackBlaze(file: Partial<AudioFileMetaDataEntity>, extension: string) {
  return `projects/${file.projectId}/${file.id}.${extension}`;
}
